"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useAddFavoriteStore: true,
  useDeleteFavoriteStore: true,
  useFavoriteStores: true,
  useOrderHistory: true,
  Account: true,
  AddressProvider: true,
  getLocationObject: true,
  OnlineOrderingStatus: true,
  provincesABR: true,
  isTestStore: true,
  useAddress: true,
  useAvailableOrderingHours: true,
  useCanStoreDeliver: true,
  useClosestDelivery: true,
  useFindDeliveryStore: true,
  useGetClosestStores: true,
  useStore: true,
  useStoreDetails: true,
  useStoreDetailsByLocation: true,
  useStoreOrderingHours: true,
  useStoreSearch: true,
  useStoreStatus: true,
  ZipPattern: true,
  Store: true,
  useCreatePayment: true,
  useCyberSourceKey: true,
  useDeletePayment: true,
  usePaymentMethods: true,
  useCreatePaymentRequest: true,
  useDeletePaymentRequest: true,
  usePaymentMethodsRequest: true,
  PaymentMethods: true,
  useSavedAddresses: true,
  useUpdatePickupAddress: true,
  useUpdateDeliveryAddress: true,
  SavedAddresses: true,
  Utils: true,
  useRequest: true,
  useAsyncRequest: true,
  GlobalStateProvider: true,
  useGlobalState: true,
  usePersistedState: true,
  createPersistedState: true,
  validateCache: true
};
Object.defineProperty(exports, "useAddFavoriteStore", {
  enumerable: true,
  get: function get() {
    return Account.useAddFavoriteStore;
  }
});
Object.defineProperty(exports, "useDeleteFavoriteStore", {
  enumerable: true,
  get: function get() {
    return Account.useDeleteFavoriteStore;
  }
});
Object.defineProperty(exports, "useFavoriteStores", {
  enumerable: true,
  get: function get() {
    return Account.useFavoriteStores;
  }
});
Object.defineProperty(exports, "useOrderHistory", {
  enumerable: true,
  get: function get() {
    return Account.useOrderHistory;
  }
});
Object.defineProperty(exports, "AddressProvider", {
  enumerable: true,
  get: function get() {
    return Store.AddressProvider;
  }
});
Object.defineProperty(exports, "getLocationObject", {
  enumerable: true,
  get: function get() {
    return Store.getLocationObject;
  }
});
Object.defineProperty(exports, "OnlineOrderingStatus", {
  enumerable: true,
  get: function get() {
    return Store.OnlineOrderingStatus;
  }
});
Object.defineProperty(exports, "provincesABR", {
  enumerable: true,
  get: function get() {
    return Store.provincesABR;
  }
});
Object.defineProperty(exports, "isTestStore", {
  enumerable: true,
  get: function get() {
    return Store.isTestStore;
  }
});
Object.defineProperty(exports, "useAddress", {
  enumerable: true,
  get: function get() {
    return Store.useAddress;
  }
});
Object.defineProperty(exports, "useAvailableOrderingHours", {
  enumerable: true,
  get: function get() {
    return Store.useAvailableOrderingHours;
  }
});
Object.defineProperty(exports, "useCanStoreDeliver", {
  enumerable: true,
  get: function get() {
    return Store.useCanStoreDeliver;
  }
});
Object.defineProperty(exports, "useClosestDelivery", {
  enumerable: true,
  get: function get() {
    return Store.useClosestDelivery;
  }
});
Object.defineProperty(exports, "useFindDeliveryStore", {
  enumerable: true,
  get: function get() {
    return Store.useFindDeliveryStore;
  }
});
Object.defineProperty(exports, "useGetClosestStores", {
  enumerable: true,
  get: function get() {
    return Store.useGetClosestStores;
  }
});
Object.defineProperty(exports, "useStore", {
  enumerable: true,
  get: function get() {
    return Store.useStore;
  }
});
Object.defineProperty(exports, "useStoreDetails", {
  enumerable: true,
  get: function get() {
    return Store.useStoreDetails;
  }
});
Object.defineProperty(exports, "useStoreDetailsByLocation", {
  enumerable: true,
  get: function get() {
    return Store.useStoreDetailsByLocation;
  }
});
Object.defineProperty(exports, "useStoreOrderingHours", {
  enumerable: true,
  get: function get() {
    return Store.useStoreOrderingHours;
  }
});
Object.defineProperty(exports, "useStoreSearch", {
  enumerable: true,
  get: function get() {
    return Store.useStoreSearch;
  }
});
Object.defineProperty(exports, "useStoreStatus", {
  enumerable: true,
  get: function get() {
    return Store.useStoreStatus;
  }
});
Object.defineProperty(exports, "ZipPattern", {
  enumerable: true,
  get: function get() {
    return Store.ZipPattern;
  }
});
Object.defineProperty(exports, "useCreatePayment", {
  enumerable: true,
  get: function get() {
    return PaymentMethods.useCreatePayment;
  }
});
Object.defineProperty(exports, "useCyberSourceKey", {
  enumerable: true,
  get: function get() {
    return PaymentMethods.useCyberSourceKey;
  }
});
Object.defineProperty(exports, "useDeletePayment", {
  enumerable: true,
  get: function get() {
    return PaymentMethods.useDeletePayment;
  }
});
Object.defineProperty(exports, "usePaymentMethods", {
  enumerable: true,
  get: function get() {
    return PaymentMethods.usePaymentMethods;
  }
});
Object.defineProperty(exports, "useCreatePaymentRequest", {
  enumerable: true,
  get: function get() {
    return PaymentMethods.useCreatePaymentRequest;
  }
});
Object.defineProperty(exports, "useDeletePaymentRequest", {
  enumerable: true,
  get: function get() {
    return PaymentMethods.useDeletePaymentRequest;
  }
});
Object.defineProperty(exports, "usePaymentMethodsRequest", {
  enumerable: true,
  get: function get() {
    return PaymentMethods.usePaymentMethodsRequest;
  }
});
Object.defineProperty(exports, "useSavedAddresses", {
  enumerable: true,
  get: function get() {
    return SavedAddresses.useSavedAddresses;
  }
});
Object.defineProperty(exports, "useUpdatePickupAddress", {
  enumerable: true,
  get: function get() {
    return SavedAddresses.useUpdatePickupAddress;
  }
});
Object.defineProperty(exports, "useUpdateDeliveryAddress", {
  enumerable: true,
  get: function get() {
    return SavedAddresses.useUpdateDeliveryAddress;
  }
});
Object.defineProperty(exports, "useRequest", {
  enumerable: true,
  get: function get() {
    return _useRequest.useRequest;
  }
});
Object.defineProperty(exports, "useAsyncRequest", {
  enumerable: true,
  get: function get() {
    return _useRequest.useAsyncRequest;
  }
});
Object.defineProperty(exports, "GlobalStateProvider", {
  enumerable: true,
  get: function get() {
    return _useGlobalState.GlobalStateProvider;
  }
});
Object.defineProperty(exports, "useGlobalState", {
  enumerable: true,
  get: function get() {
    return _useGlobalState.useGlobalState;
  }
});
Object.defineProperty(exports, "usePersistedState", {
  enumerable: true,
  get: function get() {
    return _usePersistedState.usePersistedState;
  }
});
Object.defineProperty(exports, "createPersistedState", {
  enumerable: true,
  get: function get() {
    return _usePersistedState.createPersistedState;
  }
});
Object.defineProperty(exports, "validateCache", {
  enumerable: true,
  get: function get() {
    return _validateCache.validateCache;
  }
});
exports.Utils = exports.SavedAddresses = exports.PaymentMethods = exports.Store = exports.Account = void 0;

var Account = _interopRequireWildcard(require("./account"));

exports.Account = Account;

var Store = _interopRequireWildcard(require("./store"));

exports.Store = Store;

var PaymentMethods = _interopRequireWildcard(require("./paymentMethods"));

exports.PaymentMethods = PaymentMethods;

var SavedAddresses = _interopRequireWildcard(require("./savedAddresses"));

exports.SavedAddresses = SavedAddresses;

var Utils = _interopRequireWildcard(require("./utility"));

exports.Utils = Utils;

var _menu = require("./menu");

Object.keys(_menu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _menu[key];
    }
  });
});

var _settings = require("./settings");

Object.keys(_settings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _settings[key];
    }
  });
});

var _api = require("./api");

Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _api[key];
    }
  });
});

var _context = require("./account/context");

Object.keys(_context).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _context[key];
    }
  });
});

var _hooks = require("./account/hooks");

Object.keys(_hooks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hooks[key];
    }
  });
});

var _utility2 = require("./account/utility");

Object.keys(_utility2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utility2[key];
    }
  });
});

var _utility3 = require("./api/utility");

Object.keys(_utility3).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utility3[key];
    }
  });
});

var _checkout = require("./checkout");

Object.keys(_checkout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _checkout[key];
    }
  });
});

var _locator = require("./locator");

Object.keys(_locator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locator[key];
    }
  });
});

var _deepLink = require("./deepLink");

Object.keys(_deepLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _deepLink[key];
    }
  });
});

var _useRequest = require("./useRequest");

var _useGlobalState = require("./useGlobalState");

var _usePersistedState = require("./usePersistedState");

var _validateCache = require("./validateCache");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}